import { Theme } from '@mui/material/styles'

const muiCard = (theme: Theme) => {
  return {
    styleOverrides: {
      root: {
        border: `1px solid ${theme.colors.stroke}`,
        borderRadius: 16
      }
    }
  }
}

export default muiCard
